/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ShareAndroidIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Share Android',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M27.464 24.227a4.459 4.459 0 0 0-3.157 1.3l-11.336-6.333a4.374 4.374 0 0 0 0-2.373l11.336-6.368a4.512 4.512 0 1 0-1.143-1.945l-11.319 6.359a4.473 4.473 0 1 0 0 6.282l11.319 6.327a4.472 4.472 0 1 0 4.3-3.249Z"
    />
  </svg>`;
};
